import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { moveContentFolderRequested } from 'features/content-library/actions';

export function* moveContentLibraryFolderSaga(
  action: ReturnType<typeof moveContentFolderRequested>
) {
  yield call(SignalingSocket.send, { event: 'moveLibraryFolder', data: action.payload });
}
